import type { UserSearchHit } from '@citibox-panel/api-client';
import { isCourierAccount } from './accountType';

// The one blocked state the ficha recognizes, matched EXACTLY. Unlike the block — gated on the
// `active` boolean so that a sanction is never offered on the strength of an unknown string —
// this gate does read `status`, and the exact match is what keeps it fail-closed: `anonimizado`
// and any state that does not exist yet get no action. Offering nothing on what we do not
// recognize is the point.
const BLOCKED_STATUS = 'bloqueado';

export function canUnblock(
  account: Pick<UserSearchHit, 'active' | 'status' | 'accountType'>,
): boolean {
  return isCourierAccount(account.accountType) && !account.active && account.status === BLOCKED_STATUS;
}
